var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"nav-space"}),_c('b-row',[_c('iframe',{staticClass:"blog",attrs:{"id":"blog","src":"https://www.efas.io/purchase-completed","frameborder":"0","height":"1200px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }